import React from 'react';
import i18next from 'i18next';
import { string } from 'prop-types';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';

function ProofOfDelivery({ imageLink }) {
  return (
    <Stack margin="10px">
      <Stack direction="row" spacing={2}>
        <Stack width="35%">
          <Typography variant="body2" fontWeight="fontWeightBold">
            {i18next.t(`OrdersDetails:${imageLink ? 'with' : 'without'}ProofOfDelivery`)}
          </Typography>
        </Stack>
        <Stack>
          {imageLink ? (
            <Stack spacing={0.5}>
              <Typography variant="body2">{i18next.t('OrdersDetails:proofOfDeliveryMessage')}</Typography>
              <Link href={imageLink} target="_blank" rel="noreferrer">
                {i18next.t('OrdersDetails:viewPhoto')}
              </Link>
            </Stack>
          ) : (
            <Typography variant="body2">{i18next.t('OrdersDetails:unavailable')}</Typography>
          )}
        </Stack>
      </Stack>
    </Stack>
  );
}

ProofOfDelivery.propTypes = {
  imageLink: string
};

export default ProofOfDelivery;
